/**
 * @summary register-form-sdo
 * @version 1.0.0
 * @since 1.0.0
 * @author Alex Dinari <alex.dinari@aofl.com>
 */
import {Sdo, storeInstance, state} from '@aofl/store';
import Cookies from 'js-cookie';

/**
 * @type {String}
 * @private
 */
const REGISTER_FORM = 'registerForm';

/**
 * @type {String}
 * @private
 */
const ELOG_COOKIE = 'elog_email';

/**
 * @extends {Sdo}
 */
class RegisterFormSdo extends Sdo {
  /**
   * @static
   * @type {String}
   */
  static namespace = REGISTER_FORM;

  /**
   * @static
   * @type {String}
   */
  @state()
  email = Cookies.get(ELOG_COOKIE) || '';

  /**
   * @static
   * @type {String}
   */
  @state()
  confirmEmail = '';

  /**
   * @static
   * @type {String}
   */
  @state()
  password = '';

  /**
   * @static
   * @type {String}
   */
  @state()
  confirmPassword = '';
}

/**
 * @type {RegisterFormSdo}
 * @memberof module:@aoflmkt/register-form-sdo
 */
const registerFormSdo = new RegisterFormSdo();
storeInstance.addState(registerFormSdo);

export {
  registerFormSdo
};
